import Index from 'src/pages/Suppliers/Index.vue'
import Create from 'src/pages/Suppliers/Create.vue'
import Edit from 'src/pages/Suppliers/Edit.vue'
import Show from 'src/pages/Suppliers/Show.vue'
import Restore from 'src/pages/Suppliers/Restore.vue'

const auth = { requiresAuth: true }
const saveFrom = { saveFrom: true }

export default [
  {
    path: '/suppliers',
    name: 'Lieferanten',
    component: Index,
    meta: auth
  },
  {
    path: '/suppliers/create',
    name: 'Lieferant Erstellen',
    component: Create,
    meta: auth
  },
  {
    path: '/suppliers/restore',
    name: 'Lieferant Zurücksetzen',
    component: Restore,
    meta: auth
  },
  {
    path: '/suppliers/:id',
    name: 'Lieferant',
    component: Show,
    meta: auth
  },
  {
    path: '/suppliers/:id/edit',
    name: 'Lieferant Bearbeiten',
    component: Edit,
    meta: { ...auth, ...saveFrom }
  }
]
